// ===== PRIVATE MANUALS SELECTOR
// ================================================================================

var private_manuals = {
    settings: {
        required: $('.private-manuals-selector'),
    },

    init: function () {
        if (this.settings.required.length) {
            this.bindUIActions();
        }
    },

    bindUIActions: function () {
        var $root = private_manuals.settings.required;

        $root.on('click', '[data-manual-type]', function (e) {
            e.preventDefault();

            var type = $(this).data('manualType');

            $root.find('.pm-model-grid').removeClass('is-active');
            $root.find('.pm-model-grid--' + type).addClass('is-active');

            private_manuals.goToStep($root, 'models');
        });

        $root.on('click', '[data-model]', function (e) {
            e.preventDefault();

            var model = $(this).data('model');

            $root.find('.pm-manual-list').removeClass('is-active');
            $root.find('.pm-manual-list--' + model).addClass('is-active');

            private_manuals.goToStep($root, 'manuals');
        });

        $root.on('click', '.pm-back-link', function (e) {
            e.preventDefault();

            private_manuals.goToStep($root, $(this).data('back'));
        });
    },

    goToStep: function ($root, step) {
        $root.find('.pm-step').removeClass('is-active');
        $root.find('.pm-step--' + step).addClass('is-active');

        $('html, body').animate({ scrollTop: $root.offset().top - 100 }, 400);
    },
};
private_manuals.init();
